import { DEFAULT_VERSION_CHECK_PATH, MAIN_JS_PATH } from "../constants";
import {
  RideRoutes,
  RidesViewTypeEnum,
  routePathFallbackMap,
  TPageRoute,
  TPageRouteFullPath,
} from "../enums";
import {
  entityPathMappings,
  entityPathMappingsAdmin,
  isEntityAdminPathMapped,
  isEntityPathMapped,
} from "../mappers";
import { RydeUiUnit } from "../models";
import { sessionFirstStorageHelpers } from "./browser-storge";
import { isLocalHostMode } from "./url.helpers";

export const routingEntityPath = (entity: RydeUiUnit): string => {
  if (isEntityPathMapped(entity)) {
    return entityPathMappings[entity];
  }

  if (isEntityAdminPathMapped(entity)) {
    return entityPathMappingsAdmin[entity];
  }

  return entity;
};

export const getRideAddUrl = (
  viewType: RidesViewTypeEnum | undefined,
  duplicateRouteSuffix: string,
  queryString: string,
): string => {
  switch (viewType) {
    case "CardBoard":
      return RideRoutes.ADD_CARD_BOARD + duplicateRouteSuffix + queryString;
    case "Kanban":
      return RideRoutes.ADD_KANBAN + duplicateRouteSuffix + queryString;
    case "GridSingleSelect":
      return (
        RideRoutes.ADD_GRID_SINGLE_SELECT + duplicateRouteSuffix + queryString
      );
    case "Map":
      return RideRoutes.ADD_MAP + duplicateRouteSuffix + queryString;
    case "Calendar":
      return RideRoutes.ADD_CALENDAR + duplicateRouteSuffix + queryString;
    default:
      return (
        RideRoutes.ADD_GRID_MULTI_SELECT + duplicateRouteSuffix + queryString
      );
  }
};

export const saveLastNavigation = ({
  route,
  path,
}: {
  route: TPageRoute;
  path: TPageRouteFullPath;
}): void => {
  sessionFirstStorageHelpers.setItem(route, path);
};

export const getLastNavigation = (route: TPageRoute): TPageRouteFullPath => {
  const storedSegment = sessionFirstStorageHelpers.getItem(route);

  if (!storedSegment) {
    return routePathFallbackMap[route];
  }

  return storedSegment as TPageRouteFullPath;
};

export const getLastNavigationSegmentName = (route: TPageRoute): string => {
  const segment = getLastNavigation(route);
  return segment.replace(`${route}/`, "");
};

export const getVersionJsonUrl = (): string | null => {
  if (isLocalHostMode()) {
    return DEFAULT_VERSION_CHECK_PATH;
  }

  const scripts = Array.from(document.getElementsByTagName("script"));
  const mainScript = scripts.find(s => s.src.includes(MAIN_JS_PATH));

  return mainScript
    ? mainScript.src.replace(MAIN_JS_PATH, DEFAULT_VERSION_CHECK_PATH)
    : DEFAULT_VERSION_CHECK_PATH;
};
